import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { GLOBAL_APP_DETAIL_ROUTES } from "../utils/constants/GlobalAppAndLanguage";
import useGlobalAppAndLanguage from "./useGlobalAppAndLanguage";

/** Switch the global app and leave pages that would not make sense in the new app. */
const useAppSwitchNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { handleSwitchGlobalApp } = useGlobalAppAndLanguage();

  const handleSwitchAndNavigate = ({ app, language }) => {
    const switched = handleSwitchGlobalApp({ app, language });
    if (!switched) return false;
    const detail = GLOBAL_APP_DETAIL_ROUTES.find((r) =>
      r.pattern.test(location.pathname)
    );
    if (detail) {
      navigate(detail.listPath);
    } else if (searchParams.has("page")) {
      const next = new URLSearchParams(searchParams);
      next.delete("page");
      setSearchParams(next, { replace: true });
    }
    return true;
  };

  return { handleSwitchAndNavigate };
};

export default useAppSwitchNavigation;
